// src/config.ts
const countryLocale = window.location.pathname.split('/')[1];

const getBcSupportUrl = (countryLocale: string): string => {
  // Special cases mapping
  const specialCases: Record<string, string> = {
    'en-us': 'https://enterprise-support.nvidia.com/s/create-case',
    'en-hk': 'https://www.nvidia.cn/contact/asia/',
    'en-af': 'https://www.nvidia.com/en-eu/support/consumer/',
    'en-me': 'https://www.nvidia.com/en-eu/support/consumer/',
    'nb-no': 'https://www.nvidia.com/en-eu/support/consumer/',
    'es-mx': 'https://www.nvidia.com/es-la/support/',
    'es-la': 'https://www.nvidia.com/es-la/support/',
    'pt-br': 'https://www.nvidia.com/pt-br/support/',
    'zh-tw': 'https://www.nvidia.com/zh-tw/support/',
    'en-ph': ' https://www.nvidia.com/en-us/support/consumer/',
    'en-ap': ' https://www.nvidia.com/en-us/support/',
    'en-in': ' https://www.nvidia.com/en-in/support/'
  };

  // Check if it's a special case first
  if (specialCases[countryLocale]) {
    return specialCases[countryLocale];
  }

  // Default case: build URL with consumer support
  return `https://www.nvidia.com/${countryLocale}/support/consumer/`;
};
export const config = {
  apiUrl: "https://stg-api.store.nvidia.com/",
  environment: process.env.REACT_APP_ENV,
  captchaKey: '6Lfh9kApAAAAAGmIkN9mg49NzL7-RoVpZP85hH4M',
  bcSSOLoginUrl: `https://stg.login.nvidia.com/authorize?response_type=code&client_id=6duUUSCPmF376cD3eiEgXrI8azBdf0K8MBWlO0gWR_4&redirect_uri=https://stg-api.store.nvidia.com/account/v1/auth&ui_locales=${countryLocale.replace('-', '_').split('_').map((part, index) => index === 1 ? part.toUpperCase() : part).join('_')}&scope=openid%20profile%20email%20nca&state=https://stg-marketplace.nvidia.com/`,
  bcSupportUrl: getBcSupportUrl(countryLocale),
  bcOrdersUrl: 'https://stg-marketplace.nvidia.com/' + countryLocale + '/account/my-orders',
  bcDirectOrdersUrl: 'https://stg-marketplace.nvidia.com/' + countryLocale + '/account/my-orders',
  bcAddressesUrl: 'https://stg-marketplace.nvidia.com/' + countryLocale + '/account/address-information',
  bcDirectAddressUrl: 'https://stg-marketplace.nvidia.com/' + countryLocale + '/account/address-information',
  registeredShopperAPI: 'https://stg-api.store.nvidia.com/account/v1/marketplace/customer',
  crossOriginPageUrl: 'https://preview.nvidia.com/auth/hints/',
  accountURL: 'https://stg-marketplace.nvidia.com/' + countryLocale + '/account/',
  academyURL: 'https://www.nvidia.com/en-us/training/academy'
};